import React from 'react'
import { Moon, Sun } from 'lucide-react'
import { DashboardComponentProps } from '../types/DashboardTypes'

const DarkModeToggle: React.FC<DashboardComponentProps> = ({ darkMode, setDarkMode }) => {
  return (
    <button
      onClick={() => setDarkMode(!darkMode)}
      className="p-2 rounded-full hover:bg-gray-200 dark:hover:bg-gray-700 focus:outline-none focus:ring"
    >
      {darkMode ? (
        <Sun className="h-6 w-6 text-gray-500 dark:text-gray-400" />
      ) : (
        <Moon className="h-6 w-6 text-gray-500 dark:text-gray-400" />
      )}
    </button>
  )
}

export default DarkModeToggle